export default {
  incomeInput: {
		tradeBusiness: true,
		employment: true,
		consultancyFee: true,
		otherIncome: true,
		directorFee: true,
		benefitInKind: true,
		earnedBonus: true,
		terminalBonus: true,
		contract: true,
		pension: true,
		allowances: true,
		profitShare: true,
		commission: true,
		gamesAndWinnings: true,
		estateIncome: true,
		gratuity: true,
		compensationForLossOfEmployment: true,
		honoraria: true,
		prizesAndAwards: true,
		grants: true,
	},
	untaxableIncomeInput: {
		dividend: true,
		interest: true,
		annuities: true,
		royalty: true,
		rent: true,
		discounts: true,
		incomeFromSecurities: true,
		familyIncome: true,
	},
	capitalGainsInput: {
    _section: true,
		disposalOfMoneyInstruments: true,
		digitalAssets: true,
		otherCapitalGains: true
	},
	fiiIncome: {
		dividendAmt: true,
		interestAmt: false,
		annuitiesAmt: true,
	},
	deductionsInput: {
		pensions: true,
		gratuities: true,
		bonus: false,
		otherDeductions: true,
		incomeFromSecuritiesDeduct: true,
		compensationForLossOfEmploymentDeduct: true,
	},
	adjustmentsInput: {
		balancingCharge: true,
		balancingAllowance: true,
		losses: true,
		capitalAllowance: true
	},
	reliefsInput: {
		cra: false,
		pra: false,
		personalAllowance: false,
		nationalHealthInsuranceScheme: true,
		nationalHousingFund: true,
		childrenAllowance: false,
		dependentRelatives: false,
		lifeAssurance: true,
		nationalPensionScheme: true,
		rentRelief: true,
		others: true,
		ordinaryShareHolding: true
	},
	withheldTaxesInput: {
		whtOnRent: true,
		whtOnCommission: true,
		whtOnConsultancyService: true,
		whtOnDirectorsFee: true,
		whtOnContract: true,
		whtOnInterest: true,
		whtOthers: true
	},
	othersPrepaymentsInput: {
		doubleTaxationReliefs: true,
		commonWealthIncomeTax: true,
		overPayments: true,
		paye: true,
		prepaymentBonus: false,
		paymentOnAccount: true,
	},
}